// extracted by mini-css-extract-plugin
module.exports = {"burger":"Burger_burger__1_CI6","open":"Burger_open__d0QXk","line":"Burger_line__KQfcE","box":"Burger_box__LsNB8","load":"Burger_load__ZhRx4"};